import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import {
  ContactInfoRequest,
  ContactInformation,
  ENVIRONMENT,
  UpdateContactInfoRequest,
} from '@ld.consumer-portal/models';

@Injectable({ providedIn: 'root' })
export class ContactInformationService {
  private readonly http = inject(HttpClient);
  private readonly env = inject(ENVIRONMENT);

  private get baseUrl(): string {
    return `${this.env.appSettings.melloServPaymentIntegrationUrl}/${this.env.appSettings.apiNamespace}/MelloServPaymentIntegration/CustomerContact`;
  }

  async getContactInformation(loanDetails: ContactInfoRequest[], userId: string): Promise<ContactInformation[]> {
    const params = new HttpParams().set('userId', userId);
    return firstValueFrom(
      this.http.post<ContactInformation[]>(`${this.baseUrl}/GetCustomerContact`, loanDetails, { params }),
    );
  }

  async updateContactInformation(request: UpdateContactInfoRequest): Promise<boolean> {
    return firstValueFrom(this.http.post<boolean>(`${this.baseUrl}/UpdateCustomerContact`, request));
  }
}
